import { SVGProps } from "react";
import I18n from "common/i18n";
import { getTitleFont } from "common/utils/font";

const getFreebuildText = () => {
  switch (I18n.locale) {
    case "en":
      return "Create Freely";
    case "zh_tw":
      return "自由創作";
    default:
      return "じゆうにつくる";
  }
};

export const FreebuildTitleSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 321 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M320.99 53.74V6.25c-1.23-.42-2-4.32-4.43-5.67a3.983 3.983 0 0 0-.51-.23C239.67-.18 82.12-.22 1.38 1.02l-.1 5.28-.14 7.84-.13 7.68v.68l.14 5 .25 8.28.12 4.11.31 10.54.22 7.49h-.22l5 5.19.95.87 312.55-1.95.62-.63v-.62l.04-7.04Z"
      fill="#614018"
    />
    <path
      d="M314.71 56.06v.86s.01-.31 0-.86ZM314.68 15.52c2.1.29 4.21 5.06 6.31 5.53v-6.46c-2.1-.86-4.2-6.05-6.3-6.72l-.01 7.65Z"
      fill="#614018"
    />
    <path
      d="M320.99 14.59V6.25c-1.32-.44-2.14-4.86-4.94-5.9h-1.36V8.9c2.1.66 4.25 4.83 6.3 5.69Z"
      fill="#7E5320"
    />
    <path d="M314.7 48.73v8.19l6.25 4.5v-7.68c-2.01.46-4.15-5.54-6.25-5.01Z" fill="#614018" />
    <path
      d="M314.69 49.02c2.09-.53 4.21 5.18 6.3 4.72v-6.8c-2.1-.67-4.19-8.16-6.29-8.49l-.01 10.57ZM314.7 35.02c2.1-.81 4.19 5 6.29 5.06V33.4c-2.1-.24-4.19-5.1-6.29-5.23v6.85ZM314.69 20.8c2.09 0 4.2 6.09 6.3 5.34v-5.09c-2.1-.47-4.21-5.24-6.31-5.53l.01 5.28Z"
      fill="#7E5320"
    />
    <path
      d="M314.7 35.02v7c2.1.33 4.19 4.22 6.29 4.89v-6.83c-2.05-.11-4.19-5.87-6.29-5.06ZM314.69 21.46v6.71c2.1.13 4.19 5 6.29 5.23v-7.26c-2.1.75-4.21-5.37-6.3-5.34l.01.66Z"
      fill="#614018"
    />
    <path
      d="M320.99 53.74V6.25c-1.32-.44-2.14-4.86-4.94-5.9h-1.36v56.53l6.25 4.5v-.62l.05-7.02Z"
      fill="#614018"
      style={{
        mixBlendMode: "multiply",
      }}
      opacity={0.3}
    />
    <path
      d="m315.53 56.89.63-.64-.63.64ZM2.04 57.96c.61.57.95.87.95.87s-.34-.3-.95-.87ZM1.14 14.14c104.86.3 209.733.76 314.62 1.38l.13-6.62C210.997 8.007 106.127 7.14 1.28 6.3l-.14 7.84Z"
      fill="#614018"
    />
    <path
      d="m315.94 8.9.16-8.55C239.72-.18 82.17-.22 1.43 1.02l-.1 5.28c104.86.68 209.73 1.547 314.61 2.6Z"
      fill="#7E5320"
    />
    <path
      d="m1.82 50.45.22 7.51c.61.57.95.87.95.87l312.54-1.94.63-.64-.12-7.23c-104.733.44-209.473.917-314.22 1.43Z"
      fill="#614018"
    />
    <path
      d="M1.82 50.45c104.753-.547 209.493-1.023 314.22-1.43l-.1-7c-104.83-.69-209.54-1.8-314.43-2.14l.31 10.57ZM1.39 35.8c104.64-.82 209.57-.89 314.43-.78l-.1-6.85c-104.86-.24-209.72-.457-314.58-.65l.25 8.28ZM1.01 21.82c104.8 0 209.683-.363 314.65-1.09l.1-5.21c-104.893-.487-209.767-.947-314.62-1.38l-.13 7.68Z"
      fill="#7E5320"
    />
    <path
      d="m1.39 35.8.12 4.11c104.89.34 209.6 1.45 314.43 2.14l-.12-7c-104.88-.14-209.79-.07-314.43.75ZM1 22.5l.14 5c104.873.14 209.733.357 314.58.65l-.09-5.67v-1.77C210.77 21.477 105.887 21.84.98 21.8l.02.7ZM1.82 57.94l5 5.19.95.87 312.55-1.95.62-.63-4.94-4.91c-104.707.473-209.433.95-314.18 1.43Z"
      fill="#614018"
    />
    <path
      d="m1.82 57.94 5 5.19.95.87 312.55-1.95.62-.63-4.94-4.91c-104.707.473-209.433.95-314.18 1.43Z"
      fill="#614018"
      style={{
        mixBlendMode: "multiply",
      }}
      opacity={0.3}
    />
    <text
      x="160"
      y="44"
      fill="#fff"
      fontSize="36"
      fontFamily={getTitleFont()}
      fontWeight="400"
      textAnchor="middle"
    >
      {getFreebuildText()}
    </text>
  </svg>
);

export const FreebuildMiddleSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 48" fill="none" {...props}>
    <path
      fill="#614018"
      d="M238.5 39.666V15.537l-.045-10.726c-.917-.31-1.446-3.386-3.257-4.383a2.994 2.994 0 0 0-.38-.17C177.887-.131 60.456-.161.276.754L.2 4.65l-.104 5.787L0 16.106v.502l.104 3.69.187 6.112.09 3.033.23 7.78.164 5.528-.04.178 3.603 3.653.708.642 232.962-1.44.462-.464v-.458l.03-5.196Z"
    />
    <path
      fill="#614018"
      d="M235.327 43.827v.67s.007-.242 0-.67ZM235.544 12.294c.999.223 2.002 3.885 3 4.245V11.58c-.998-.66-1.996-4.644-2.995-5.158l-.005 5.872Z"
    />
    <path
      fill="#7E5320"
      d="M238.544 11.87V5.032c-.628-.36-1.019-3.984-2.352-4.837h-.648v7.01c1 .54 2.024 3.96 3 4.665Z"
    />
    <path fill="#614018" d="M235.544 38.356V44.368l3 3.303V42.035c-.964.338-1.992-4.067-3-3.678Z" />
    <path
      fill="#7E5320"
      d="M235.544 38.364c.996-.43 2.005 4.212 3 3.838v-5.529c-1-.544-1.995-6.634-2.995-6.902l-.005 8.593ZM235.544 27.36c1.002-.636 1.999 3.92 3 3.967V26.09c-1.001-.188-1.998-4-3-4.101v5.371ZM235.549 16.494c.994 0 1.997 4.437 2.995 3.89v-3.707c-.998-.343-2.001-3.818-3-4.029l.005 3.846Z"
    />
    <path
      fill="#614018"
      d="M235.544 27.497v5.462c1.002.258 1.999 3.293 3 3.816v-5.33c-.977-.086-1.998-4.58-3-3.948ZM235.549 17.029v4.974c1 .096 1.995 3.706 2.995 3.876v-5.381c-1 .556-2.004-3.98-3-3.958l.005.489Z"
    />
    <path
      fill="#614018"
      d="M238.544 41.826V5.488c-.628-.337-1.019-3.719-2.352-4.514h-.648V44.228l2.977 3.444v-.475l.023-5.371Z"
      opacity={0.3}
      style={{
        mixBlendMode: "multiply",
      }}
    />
    <path
      fill="#614018"
      d="m235.942 44.473.472-.498-.472.498ZM.795 45.305c.457.444.712.678.712.678s-.255-.234-.712-.678ZM.12 11.2c78.655.234 157.32.592 235.995 1.074l.097-5.152C157.532 6.427 78.87 5.752.225 5.1L.12 11.2Z"
    />
    <path
      fill="#7E5320"
      d="m236.175 7.2.12-7.005C178.961-.222 60.697.022.09.998L.015 5.154c78.713.535 157.432 1.217 236.16 2.046Z"
    />
    <path
      fill="#614018"
      d="m.63 39.46.165 5.846c.457.443.712.677.712.677l234.435-1.51.472-.498-.09-5.628C157.765 38.69 79.2 39.061.63 39.461Z"
    />
    <path
      fill="#7E5320"
      d="M.63 39.46c78.575-.425 157.14-.796 235.694-1.113l-.075-5.448C157.617 32.362 79.075 31.5.397 31.234L.63 39.46ZM.308 28.058c78.49-.638 157.197-.692 235.852-.607l-.075-5.331c-78.655-.187-157.31-.355-235.965-.506l.188 6.444ZM.022 17.178c78.61 0 157.283-.283 236.017-.849l.075-4.055C157.435 11.896 78.77 11.538.12 11.2l-.098 5.978Z"
    />
    <path
      fill="#614018"
      d="m.308 28.058.09 3.2c78.677.264 157.219 1.128 235.852 1.665l-.09-5.448c-78.67-.11-157.363-.055-235.852.583ZM.015 17.707l.105 3.892c78.665.108 157.32.277 235.965.505l-.068-4.413v-1.377c-78.655.596-157.327.88-236.017.848l.015.545ZM.75 44.902l.75 1.161 3.75 1.161 232.788-.175.462-.244-3.68-1.903c-78.009.183-156.032-.186-234.07 0Z"
    />
    <path
      fill="#614018"
      d="m.75 45.345 3.702 1.61.703.27 231.386-.605.459-.196-3.657-1.522c-77.516.146-155.047.294-232.593.443Z"
      opacity={0.3}
      style={{
        mixBlendMode: "multiply",
      }}
    />
    <text
      x="120"
      y="33"
      fill="#fff"
      fontSize="27"
      fontFamily={getTitleFont()}
      fontWeight="400"
      textAnchor="middle"
    >
      {getFreebuildText()}
    </text>
  </svg>
);

export const FreebuildTitleSmallSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106 24" fill="none" {...props}>
    <path
      fill="#614018"
      d="M105.98 20.159V7.896l-.02-5.45c-.408-.158-.643-1.722-1.447-2.228a1.29 1.29 0 0 0-.169-.087C79.046-.067 26.864-.082.123.383l-.034 1.98-.046 2.941L0 8.185v.255l.046 1.876.083 3.106.04 1.541.103 3.954.072 2.81-.017.09 1.6 1.857.315.326 103.519-.732.206-.236v-.233l.013-2.64Z"
    />
    <path
      fill="#614018"
      d="M104.57 22.273v.34s.004-.122 0-.34ZM104.667 6.248c.443.113.889 1.974 1.333 2.158v-2.52c-.444-.336-.888-2.36-1.331-2.622l-.002 2.984Z"
    />
    <path
      fill="#7E5320"
      d="M106 6.033V2.558c-.28-.183-.453-2.025-1.046-2.458h-.287v3.562c.444.275.899 2.012 1.333 2.37Z"
    />
    <path
      fill="#614018"
      d="M104.667 19.494v2.734c0 .206-.033.641-.033.641l1.006 1.017h.36v-2.523c.021.37-.885-2.067-1.333-1.87Z"
    />
    <path
      fill="#7E5320"
      d="M104.667 19.497c.442-.219.89 2.14 1.333 1.95v-2.81c-.445-.276-.887-3.37-1.331-3.507l-.002 4.367ZM104.667 13.904c.445-.323.888 1.992 1.333 2.016v-2.662c-.445-.095-.888-2.032-1.333-2.084v2.73ZM104.669 8.382c.441 0 .887 2.255 1.331 1.977V8.475c-.444-.174-.89-1.94-1.333-2.047l.002 1.954Z"
    />
    <path
      fill="#614018"
      d="M104.667 13.974v2.776c.445.131.888 1.674 1.333 1.94V15.98c-.435-.043-.888-2.328-1.333-2.007ZM104.669 8.655v2.528c.444.049.886 1.883 1.331 1.97v-2.735c-.445.282-.891-2.023-1.333-2.012l.002.249Z"
    />
    <path
      fill="#614018"
      d="M105.64 20.45V2.26c-.21-.169-.341-1.862-.789-2.26h-.217v21.654l.998 1.723v-.238l.008-2.689Z"
      opacity={0.3}
      style={{
        mixBlendMode: "multiply",
      }}
    />
    <path
      fill="#614018"
      d="m104.844 22.6.211-.252-.211.253ZM.353 23.024c.203.226.317.345.317.345s-.114-.12-.317-.345ZM.054 5.693c34.95.118 69.906.3 104.866.546l.043-2.619C70.001 3.267 35.047 2.924.1 2.592l-.046 3.1Z"
    />
    <path
      fill="#7E5320"
      d="M104.947 3.659 105 .099C79.523-.113 26.971.011.04.507L.007 2.62c34.976.272 69.956.619 104.94 1.04Z"
    />
    <path
      fill="#614018"
      d="m.28 20.055.074 2.97c.203.226.317.345.317.345l104.173-.768.21-.253-.04-2.86c-34.909.174-69.82.363-104.733.566Z"
    />
    <path
      fill="#7E5320"
      d="M.28 20.055c34.916-.216 69.827-.405 104.734-.566l-.034-2.768c-34.94-.273-69.842-.712-104.803-.847l.104 4.18ZM.137 14.26c34.878-.325 69.852-.353 104.803-.31l-.033-2.708c-34.951-.096-69.902-.181-104.853-.258l.083 3.275ZM.01 8.73c34.931 0 69.89-.144 104.877-.431l.033-2.06C69.958 6.045 35.002 5.863.054 5.691L.01 8.73Z"
    />
    <path
      fill="#614018"
      d="m.136 14.259.04 1.625c34.96.135 69.862.574 104.803.847l-.04-2.769c-34.958-.055-69.925-.028-104.803.297ZM.007 8.999l.046 1.978c34.956.055 69.907.14 104.853.257l-.03-2.243v-.7c-34.95.303-69.91.447-104.876.431L.007 9ZM.334 22.82l.333.59 1.667.59 103.441-.09.206-.123-1.636-.968c-34.664.094-69.334-.094-104.011 0Z"
    />
    <path
      fill="#614018"
      d="m.334 23.045 1.645.818.312.137 102.819-.308.204-.099-1.625-.774-103.355.226Z"
      opacity={0.3}
      style={{
        mixBlendMode: "multiply",
      }}
    />
    <text
      x="53"
      y="17"
      fill="#fff"
      fontSize="12"
      fontFamily={getTitleFont()}
      fontWeight="400"
      textAnchor="middle"
    >
      {getFreebuildText()}
    </text>
  </svg>
);
